"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_jss_1 = require("react-jss");
const react_modal_1 = __importDefault(require("react-modal"));
const maple_pizza_logo_svg_1 = __importDefault(require("../../svg/maple-pizza-logo.svg"));
const useStyles = (0, react_jss_1.createUseStyles)({
    maplePizza: {
        width: 90,
        position: "fixed",
        left: 10,
        bottom: 10,
        cursor: "pointer",
        outline: "none",
        border: "none",
        "&:focus #outline, &:focus-visible #outline": {
            fill: "#155755",
        },
    },
    nameLinkedid: {
        fontFamily: '"Bubblegum Sans", cursive',
        fontSize: 25,
        textDecoration: "none",
        color: "var(--tiffany-extra-dark)",
        margin: 5,
    },
    textInModal: {
        fontFamily: '"Bubblegum Sans", cursive',
        fontSize: 20,
        color: "#999595",
    },
});
const modalContentStyles = {
    background: "white",
    borderRadius: 5,
    padding: 10,
    position: "fixed",
    top: "auto",
    right: "auto",
    left: 10,
    bottom: 100,
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    boxShadow: "0px 1px 2px #0006",
    borderColor: "transparent",
};
const modalOverlayStyles = {
    zIndex: 1,
    backgroundColor: "transparent",
};
const LogoPopup = () => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const classes = useStyles();
    const open = (0, react_1.useCallback)(() => setIsOpen(true), []);
    const close = (0, react_1.useCallback)(() => setIsOpen(false), []);
    const toggle = (0, react_1.useCallback)(() => (isOpen ? setIsOpen(false) : setIsOpen(true)), []);
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(maple_pizza_logo_svg_1.default, { className: classes.maplePizza, onClick: open, onKeyDown: (e) => (e.key === "Enter" ? toggle() : {}), tabIndex: 0 }),
        react_1.default.createElement(react_modal_1.default, { isOpen: isOpen, style: { overlay: modalOverlayStyles, content: modalContentStyles }, onRequestClose: close },
            react_1.default.createElement("div", { className: classes.textInModal }, "Created by:"),
            react_1.default.createElement("a", { className: classes.nameLinkedid, href: "https://portfolio.marcelrobitaille.me/" }, "Marcel"),
            react_1.default.createElement("div", { className: classes.textInModal }, "&"),
            react_1.default.createElement("a", { className: classes.nameLinkedid, href: "https://www.fedetommi.eu/" }, "FedeTommi"))));
};
exports.default = LogoPopup;
